// @flow

import clsx from 'clsx';
import * as React from 'react';

import styles from './Status.scss';

export type StatusProps = {|
  children: React.Node,
  dotted: boolean,
  theme?: 'success' | 'info' | 'warning' | 'danger',
  href: string,
|};

const Status = (props: StatusProps): React.Element<'a'> => {
  const { children, dotted, theme, ...extraProps } = props;

  const rootClasses = clsx(
    styles.root,
    theme ? styles[`theme-${theme}`] : null,
    {
      [styles.dotted]: dotted,
    }
  );

  return (
    <a className={rootClasses} {...extraProps}>
      {children}
    </a>
  );
};

export default Status;
